/*
 * @Author: 黄智强
 * @Date: 2018-01-27 09:56:30
 * @Last Modified by: 黄智强
 * @Last Modified time: 2018-01-27 09:56:51
 * @说明：认证(auth)相关接口地址
 */

// 获取认证信息
export const getAuthInfo = '/auth/get-auth-info'
export const agreementSign = '/auth/agreement-sign'
export const personQualification = '/auth/person-qualification'
export const companyQualification = '/auth/company-qualification'
export const receiveAccount = '/auth/receive-account'
export const submitApplication = '/auth/submit-application'
export const getStepInfo = '/auth/get-step-info'
export const bankList = '/auth/bank-list'
export const saveAuthInfo = '/auth/save-auth-info'
